import React,{useState} from 'react';
import Modal from "react-bootstrap/Modal";
import Wrp from '../../../hoc/Wrp/Wrp';

const CreatePDF = (props) => {
	const {toggleCreatePDfModel,createPDFModalOpen,savePDFHandler,createPDFChangeHandler,pdfData,windowList} = props;
	const {designName,description,isActive,isDefault,format,formatOptions,height,width,designName_error,is_window,window_id} = pdfData;
	return(
		<Modal size="lg" show={createPDFModalOpen} >
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2">PDF Template </h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
            		<div className="col-6">
                        <div className={designName_error.trim() != "" ? "form-group has-error" : "form-group "}>
                            <label> Name</label>
                            <input type="text" className="form-control" name="designName" value={designName} onChange={createPDFChangeHandler}/>
                            {designName_error.trim() !== "" ? 
                                <label className="error m-0">{designName_error}</label>
                                : null
                            }
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label> Format</label>
                            <select name="format" value={format} className="form-control" onChange={createPDFChangeHandler}>
                            	<option value=""></option>
                            	{formatOptions ?
                            		formatOptions.map((opt,ind) => {
                            			return <option value={opt.value} key={ind}>{opt.label}</option>
                            		})
                            	:null}
                            </select>
                        </div>
                    </div>
                    {format === "Custom" ?
                    <Wrp>
                    	<div className="col-6">
	                        <div className="form-group">
	                            <label> Width</label>
	                            <div className="input-group">
	                            	<input type="number" className="form-control" name="width" value={width} onChange={createPDFChangeHandler}/>
	                            	<div className="input-group-append"><a className="input-group-text">mm</a></div>
                            	</div>
	                        </div>
	                    </div>
	                    <div className="col-6">
	                        <div className="form-group">
	                            <label> Height</label>
	                            <div className="input-group">
	                            	<input type="number" className="form-control" name="height" value={height} onChange={createPDFChangeHandler}/>
	                            	<div className="input-group-append"><a className="input-group-text">mm</a></div>
                            	</div>
	                        </div>
	                    </div>
                    </Wrp>
                    :null}
                    <div className="col-4">
                        <div className="form-group">
                            <label> Is Active</label>
                            <div className="material-switch pt-2">
                            	<input type="checkbox" id="isActive" className="form-control" checked={isActive} name="isActive" onChange={createPDFChangeHandler}/>
                        		<label htmlFor="isActive" className="secondary_bg"></label>
                        	</div>
                            
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="form-group">
                            <label> Is Default</label>
                            <div className="material-switch pt-2">
                            	<input type="checkbox" id="isDefault" className="form-control" checked={isDefault} name="isDefault" onChange={createPDFChangeHandler}/>
                        		<label htmlFor="isDefault" className="secondary_bg"></label>
                        	</div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="form-group">
                            <label> Is Window Field </label>
                            <div className="material-switch p-2">
                                <input id="is_window" name="is_window" type="checkbox" checked={is_window} onChange={createPDFChangeHandler}/>
                                <label htmlFor="is_window" className="secondary_bg"></label>
                            </div>
                        </div>
                    </div>
                    {is_window === true ?
                        <div className="col-12">
                            <div className="form-group">
                                <label> Window </label>
                                <div className="material-switch p-2">
                                    <select className="form-control" name="window_id" value={window_id} onChange={createPDFChangeHandler}>
                                        <option value=""></option>
                                        {windowList && windowList.length>0 ?
                                            windowList.map((item,ind) => {
                                                return <option key={ind} value={item.value}>{item.name}</option>
                                            })
                                        : null}
                                    </select>
                                </div>
                            </div>
                        </div>
                    : null}
                    <div className="col-12">
                        <div className="form-group">
                            <label> Description</label>
                            <textarea className="form-control" name="description" value={description} onChange={createPDFChangeHandler}></textarea>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-between"> 
                <a onClick={toggleCreatePDfModel} className="btn btn-border border-default mr-2" data-dismiss="modal"> Cancel </a> 
                <a onClick={savePDFHandler} className="btn primary_bg" data-dismiss="modal"> Save </a>                  
            </Modal.Footer>
		</Modal>
	)

}

export default CreatePDF;